import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { BajaFiestaComponent } from './baja-fiesta.component';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule
  ],
  declarations: [
    BajaFiestaComponent,
  ],
  providers: [
  ]
})
export class BajaFiestaModule { }



// WEBPACK FOOTER //
// ./src/app/baja-fiesta/baja-fiesta.module.ts